import  { useState } from 'react'
import './CampaingDetailProfileAndProduct.scss'
import CardCostCampaing from '../../Molecules/CardCostCampaing/CardCostCampaing'
import GroupOfButtons from '../../Molecules/GroupOfButtons/GroupOfButtons'
import StartEndAndFrequency from '../../Organisms/StartEndAndFrequency/StartEndAndFrequency'
import HeaderTitle from '../../Molecules/HeaderTitle/HeaderTitle'


const CampaingDetailProfileAndProduct = () => {
  const [formsHandler, setFormsHandler] = useState({
    showForm1: true,
    showForm2: false,
  });


  return (
    <div className="nd-grid">
      <HeaderTitle
        headerText="Editar campaña"
        withDivider
      />
      <div>
        <h3 className="mb-5 poppins-28 line-clamp mb-30">Nombre de la campaña creadare max. 70 caracteres campaña campaña campaña campaña campaña</h3>
        
        <CardCostCampaing cost={12} balance={15} />

        <GroupOfButtons
          content={{ first: "Detalles, Perfiles y Productos", second: "Cliente, Nivel y tipos de servicios" }}
          formsHandler={formsHandler}
          customClass="mt-30"
          setFormsHandler={setFormsHandler} 
        />

        {
          formsHandler.showForm1 &&
          <StartEndAndFrequency />
        }
        {
          formsHandler.showForm2 &&
          <div className="box s-pxy-20 m-pxy-50 mt-30">
          <p className="source-24 mb-20">Indica el nivel de servicio</p>
        </div>
        }

      </div>
    </div>
  )
}

export default CampaingDetailProfileAndProduct
